module.exports = __webpack_public_path__ + "static/media/image-04.be092be3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sections/image-04.jpg
// module id = 114
// module chunks = 0